import { Card, Group, Stack, Text } from 'ui';

import { useFormListValidation } from '../../../..';
import { AccountCode, useShowAccountCodeById } from '../../../../api';
import { AccountCodeSearchForm } from './types';

type NewOldAccountCodeDisplayProps = {
  causeId: string;
  accountCode?: AccountCode;
  isEdit?: boolean;
};

const NewOldAccountCodeDisplay = ({
  causeId,
  accountCode,
  isEdit = true,
}: NewOldAccountCodeDisplayProps) => {
  const { useGetForm } = useFormListValidation<AccountCodeSearchForm>();
  const form = useGetForm('account_code');

  const { data: newAccountCode } = useShowAccountCodeById({
    causeId,
    codeId: form?.values?.accountCode,
  });

  return (
    <Card radius="sm" bg="gray.0">
      <Stack gap={4}>
        <Group>
          <Text c="gray" type="caption" fw={500} miw="120px">
            Old Account Code:
          </Text>
          <Text c="gray" type="caption">
            {accountCode ? `${accountCode?.name}: ${accountCode?.code}` : 'None'}
          </Text>
        </Group>
        <Group>
          <Text c="gray" type="caption" fw={500} miw="120px">
            New Account Code:
          </Text>
          <Text c="gray" type="caption">
            {newAccountCode && isEdit
              ? `${newAccountCode?.account_code?.name}: ${newAccountCode?.account_code?.code}`
              : 'None'}
          </Text>
        </Group>
      </Stack>
    </Card>
  );
};

export { NewOldAccountCodeDisplay };
